import {createNamespacedHelpers} from "vuex";

const {mapState, mapGetters} = createNamespacedHelpers('audienceManager/builder');

/**
 * Comparer for objects containing a numerical `index` property
 * @param {{index: number}} left Left object
 * @param {{index: number}} right Right object
 * @return {number} Sorting weight
 */
const indexComparer = ({index: left}, {index: right}) => {
    return left > right ? 1 : -1;
};

export default {
    name: "Answers",
    computed: {
        ...mapState(['answerValues', 'categories']),
        ...mapGetters(['questionOptions']),
        
        sortedQuestions(){
            //We need to copy our questions to a new array to avoid altering the original array
            //the original array is managed by Vuex
            return Object.values(this.categories)
                .sort(indexComparer)
                .flatMap(({questions}) => [...questions].sort(indexComparer));
        },

        /**
         * All sorted questions with answers, a single question may appear multiple times
         * @return {Array<{ question: string, answer: string }>}
         */
        questionAnswers(){
            return this.sortedQuestions.flatMap(question => {
                //Most questions support answers; thus we should use a map instead of Array.prototype.find(...)
                const optionValueLabelMap = this.questionOptions(question.id).reduce((map, option) => {
                    map.set(option.value, option.label);
                    return map;
                }, new Map());

                return (this.answerValues[question.id] || []).map(answer => ({
                    question: question.name,
                    answer: optionValueLabelMap.get(answer) || answer
                }));
            });
        }
    }
}